/*
 * Overlay chevrons on the product media gallery.
 * Mobile (<750px): drives the existing slider so scroll-snap/swipe state stays
 * consistent; wraps around at either end.
 * Desktop: changes the active media directly (thumbnail layouts show one main
 * image at a time), also with wrap-around.
 */
(function () {
  document.querySelectorAll('[data-gallery-nav]').forEach((button) => {
    button.addEventListener('click', () => {
      const direction = button.dataset.galleryNav === 'next' ? 1 : -1;
      const gallery = button.closest('media-gallery');
      const viewer = gallery.querySelector('[id^="GalleryViewer"]');
      const isDesktop = window.matchMedia('(min-width: 750px)').matches;

      if (!isDesktop) {
        const sliderButton = viewer.querySelector(direction === 1 ? '.slider-button--next' : '.slider-button--prev');
        if (sliderButton && !sliderButton.disabled) {
          sliderButton.click();
          return;
        }
        const list = viewer.querySelector('.product__media-list');
        if (list) list.scrollTo({ left: direction === 1 ? 0 : list.scrollWidth, behavior: 'smooth' });
        return;
      }

      const items = Array.from(viewer.querySelectorAll('.product__media-item')).filter(
        (item) => !item.classList.contains('product__media-item--variant') || item.classList.contains('is-active')
      );
      if (items.length < 2) return;
      const currentIndex = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));
      const nextItem = items[(currentIndex + direction + items.length) % items.length];
      gallery.setActiveMedia(nextItem.dataset.mediaId, false);
    });
  });
})();
